import { IconBrandYahoo } from "@tabler/icons";
import React, { useState } from "react";
import { google, ics, outlook, yahoo } from "calendar-link";
import { Divider, message } from "antd";
import { appLinks, cancelReasons, FEEDBACK } from "../../helpers/config";
import {
  Chip,
  Loader,
  ActionIcon,
  Affix,
  Text,
  Badge,
  Modal,
  Timeline,
} from "@mantine/core";
import _ from "lodash";
import { Rating } from "react-simple-star-rating";
import {
  getConsultationFeedback,
  getMembershipSubscription,
  getMembershipBenefits,
  getBenefitsRedemptions,
  getPayoutById,
} from "../../helpers/api";
import { useQuery } from "react-query";
import { IconBell, IconFirstAidKit, IconHistory } from "@tabler/icons";
import { useNavigate } from "react-router-dom";
import {
  IconCircleCheck,
  IconUser,
  IconCreditCard,
  IconReceipt,
  IconCalendar,
  IconBuilding,
} from "@tabler/icons";
import { cedisLocale } from "../../helpers/utilities";
import { CareValueChart } from "../charts";
import { format } from "date-fns";
import { MEMBERSHIP_BENEFIT_TYPE } from "../../helpers/config";
import { Input, Select } from "antd";

export const AppVersion = ({ showTitle = true, className }) => {
  return (
    <div className={className}>
      {showTitle && "CareOS "} v{process.env.REACT_APP_VERSION}
    </div>
  );
};

export const AddToCalendarComponent = ({ event }) => {
  return (
    <div>
      <p className="text-muted">
        Select your favourite calendar to add appointment schedule to
      </p>
      <div className="buttons">
        <button
          onClick={() => window.open(google(event), "_blank", "noreferrer")}
          className="button w-100">
          <span className="bi bi-google me-2"></span>
          Google Calendar
        </button>
        <button
          onClick={() => window.open(outlook(event), "_blank", "noreferrer")}
          className="button w-100">
          <span className="bi bi-envelope me-2" />
          Outlook Calendar
        </button>
        <button
          onClick={() => window.open(yahoo(event), "_blank", "noreferrer")}
          className="button w-100">
          <IconBrandYahoo className="me-2" />
          Yahoo Calendar
        </button>
        <button
          onClick={() => window.open(ics(event), "_blank", "noreferrer")}
          className="button w-100">
          <span className="bi bi-download me-2"></span>
          Download ICS File
        </button>
      </div>
    </div>
  );
};

export const CopyRightTag = ({ className }) => {
  return <div className={className}>@Rivia {new Date().getUTCFullYear()}</div>;
};
// <small className='mt-0 pt-0'><AppVersion /></small>

export const DetailTile = ({
  title,
  detail,
  icon,
  className,
  firstCol,
  secondCol,
}) => {
  return (
    <div className={`row ${className}`}>
      <div className={`${firstCol ?? "col-md-3"} col`}>
        <span className={`bi bi-${icon} h5 me-3`}></span>
        <strong>{title}</strong>
      </div>
      <div className={`${secondCol ?? "col-md-9"} col`}>{detail}</div>
    </div>
  );
};

export const CancelAppointment = ({ reason, onUpdate, onCancel, loading }) => {
  return (
    <>
      <div className="row">
        <div className="field col-12">
          <kbd className="bg-danger">
            Cancelling an appointment cannot be undone!
          </kbd>
          <label className="mb-0" htmlFor="cancelReason">
            Cancel Reason
          </label>
          <textarea
            className="textarea"
            id="cancelReason"
            placeholder="reason for cancelling appointment"
            value={reason}
            onChange={(e) => onUpdate(e.target.value)}></textarea>
          <small>why are you cancelling this appointment?</small>
          <Divider />
        </div>
        <div className="mb-3">
          {cancelReasons.map((res) => (
            <Chip
              onClick={() => {
                if (!reason.includes(res))
                  onUpdate(reason ? `${reason} - ${res}` : res);
              }}
              className="d-inline-block mb-1"
              title={res}>
              {res}
            </Chip>
          ))}
        </div>
      </div>
      <button
        className={`button is-danger mt-2 ${loading && " is-loading"}`}
        onClick={onCancel}>
        Cancel
      </button>
    </>
  );
};

export const FeedBackForm = ({ onSubmit, isLoading }) => {
  const [state, setState] = useState({ rating: 0, reasons: [], comments: "" });

  const handleAddReason = (reason) => {
    if (state.reasons.includes(reason))
      setState({
        ...state,
        reasons: state.reasons.filter((r) => r !== reason),
      });
    else setState({ ...state, reasons: [...state.reasons, reason] });
  };

  return (
    <div className="row">
      <h4>Rate Your Experience</h4>
      <div className="row">
        <label className="mb-0 label mb-2" htmlFor="comments">
          How do you feel about the service?
        </label>
        <div className="col-12">
          <Rating
            size={50}
            initialValue={state.rating}
            onClick={(value) =>
              value !== state.rating &&
              setState({ ...state, reasons: [], rating: parseInt(value) })
            }
            showTooltip
            tooltipArray={["Terrible", "Average", "Good", "Awesome", "Wow"]}
          />
        </div>
      </div>
      {state.rating && (
        <div className="row">
          <Divider />
          <label className="mb-0 label mb-2" htmlFor="">
            What is the reason?
          </label>
          {FEEDBACK.reasons
            .filter((res) => res.rate === state.rating)
            .map((res) => (
              <div className="col mb-2" key={res.value}>
                <Chip
                  size="md"
                  checked={state.reasons.includes(res.value)}
                  onClick={() => handleAddReason(res.value)}>
                  {res.reason}
                </Chip>
              </div>
            ))}
        </div>
      )}
      <Divider />
      <div className="row">
        <div className="col-12">
          <div className="field">
            <label className="mb-0 label" htmlFor="comments">
              We love to know more
            </label>
            <textarea
              className="textarea"
              name="comments"
              id="comments"
              onChange={(e) => setState({ ...state, comments: e.target.value })}
              value={state.comments}
              placeholder="leave your comments here"></textarea>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <button
          onClick={() =>
            onSubmit({ ...state, reasons: state.reasons.toString() })
          }
          className={`button h6 app-btn btn-prim ${isLoading && " is-loading"
            }`}>
          <span className="bi bi-check-circle me-2" />
          Submit Feedback
        </button>
      </div>
    </div>
  );
};

export const FeedBackView = ({ consultationId }) => {
  const {
    data: state = {},
    isLoading,
    refetch,
  } = useQuery({
    queryFn: () => getConsultationFeedback(consultationId),
    queryKey: ["consultation-feedback", consultationId],
  });

  return (
    <div className="row">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <h4>Patient Feedback</h4>
          <div className="row">
            <label className="mb-0 label mb-2" htmlFor="">
              Rating
            </label>
            <div className="col-12">
              <Rating
                size={50}
                disableFillHover
                initialValue={state.rating}
                showTooltip
                tooltipArray={["Terrible", "Average", "Good", "Awesome", "Wow"]}
              />
            </div>
          </div>
          {state.reasons && (
            <div className="row">
              <Divider />
              <div className="col-12">
                <label className="mb-0 label mb-2" htmlFor="comments">
                  Reasons
                </label>
                <ol>
                  {state?.reasons?.split(",").map((reason, index) => (
                    <li key={index}>
                      {_.upperCase(reason).replace("-", " ").replace("_", " ")}
                    </li>
                  ))}
                </ol>
              </div>
            </div>
          )}
          <Divider />
          <div className="row">
            <div className="col-12">
              <div className="field">
                <label className="mb-0 label" htmlFor="comments">
                  Comments
                </label>
                <textarea
                  className="textarea"
                  name="comments"
                  id="comments"
                  disabled
                  value={state.comments}
                  placeholder="patient comments"></textarea>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export const RatingDisplay = ({ rate, total = 5, className }) => {
  return (
    <span className={`${className}`}>
      {rate > 0 ? (
        <div className="d-flex align-items-center">
          <h5 className="mb-0">{rate}</h5>
          <small>/{total}</small>
        </div>
      ) : (
        <span>-</span>
      )}
    </span>
  );
};

export const ActionButton = ({ onClick }) => {
  return (
    <>
      <Affix onClick={onClick} position={{ bottom: 20, right: 20 }}>
        <ActionIcon color="blue" radius="xl" size={60}>
          <IconBell stroke={1.5} size={30} />
        </ActionIcon>
      </Affix>
    </>
  );
};

export const OTPConfirmation = ({
  onSubmit,
  isLoading,
  label,
  placeholder,
}) => {
  const [otp, setOTP] = useState("");

  return (
    <div>
      <label className="label">{label || "Confirm OTP Code"}</label>
      <input
        type="text"
        className="input"
        placeholder={placeholder || "confirm the OTP code sent"}
        onChange={(e) => setOTP(e.target.value)}
      />
      <button
        onClick={(e) => {
          e.preventDefault();
          onSubmit(otp);
        }}
        className={`button mt-3 h6 app-btn btn-prim py-3 px-2 w-100  ${isLoading && "is-loading"
          }`}>
        Confirm
      </button>
    </div>
  );
};

export const MembershipUtilization = ({ membershipId }) => {
  const { data: redemptions, isLoading } = useQuery({
    queryFn: () => getBenefitsRedemptions(membershipId, 500),
    queryKey: ["benefits-redemptions", membershipId],
  });

  const [facilityFilter, setFacilityFilter] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);

  const { Option } = Select;

  // Get unique facilities for filter
  const facilities = _.uniq(
    (redemptions || [])
      .map(
        (r) =>
          r?.bill?.branch?.facility?.facilityName &&
          `${r?.bill?.branch?.facility?.facilityName} (${r?.bill?.branch?.branchName})`
      )
      .filter(Boolean)
  );

  // Date range picker component
  function DateRangeInputs({ value, onChange }) {
    return (
      <div className="d-flex gap-2 align-items-center w-100">
        <input
          type="date"
          className="form-control form-control-sm"
          value={value[0] || ""}
          onChange={(e) => onChange([e.target.value, value[1]])}
        />
        <span className="text-muted  text-nowrap">to</span>
        <input
          type="date"
          className="form-control form-control-sm"
          value={value[1] || ""}
          onChange={(e) => onChange([value[0], e.target.value])}
        />
      </div>
    );
  }

  // Filter redemptions by facility and date range
  const filteredRedemptions = (redemptions || []).filter((r) => {
    // Facility filter
    let facilityOk = true;
    if (facilityFilter) {
      const facilityName = `${r?.bill?.branch?.facility?.facilityName} (${r?.bill?.branch?.branchName})`;
      facilityOk = facilityName === facilityFilter;
    }

    // Date range filter
    let dateOk = true;
    if (dateRange[0] && dateRange[1]) {
      const created = new Date(r.createdAt);
      dateOk =
        created >= new Date(dateRange[0]) && created <= new Date(dateRange[1]);
    }

    return facilityOk && dateOk;
  });

  // Calculate summary statistics
  const totalVisits = filteredRedemptions.length;
  const totalCreditsUsed = filteredRedemptions.reduce(
    (sum, r) => sum + (r.amountRedeemed || 0),
    0
  );
  // Count unique branches only (not facility+branch)
  const totalLocations = _.uniq(
    filteredRedemptions.map((r) => r?.bill?.branch?.branchName).filter(Boolean)
  ).length;

  if (isLoading) {
    return (
      <div className="text-center p-4">
        <Loader size="lg" />
        <div className="mt-2 text-muted">Loading utilization history...</div>
      </div>
    );
  }

  return (
    <div>
      <div className="row g-3 mb-4">
        <div className="col-md-4">
          <div className="border rounded-3 p-3 bg-light">
            <div className="text-muted small mb-1">Total Visits</div>
            <div className="fw-bold fs-4 text-primary">{totalVisits}</div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="border rounded-3 p-3 bg-light">
            <div className="text-muted small mb-1">Total Value Used</div>
            <div className="fw-bold fs-4 text-success">
              GHS {cedisLocale.format(totalCreditsUsed)}
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="border rounded-3 p-3 bg-light">
            <div className="text-muted small mb-1">Total Locations</div>
            <div className="fw-bold fs-4 text-info">{totalLocations}</div>
          </div>
        </div>
      </div>

      {/* Search and Filter Row */}
      <div className="mb-4">
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label small text-muted">
              Filter by Facility
            </label>
            <Select
              className="w-100"
              placeholder="All Facilities"
              value={facilityFilter}
              onChange={setFacilityFilter}
              allowClear>
              {facilities.map((facility) => (
                <Option key={facility} value={facility}>
                  {facility}
                </Option>
              ))}
            </Select>
          </div>
          <div className="col-md-6">
            <label className="form-label small text-muted">
              Filter by Date Range
            </label>
            <DateRangeInputs value={dateRange} onChange={setDateRange} />
          </div>
        </div>
        {(facilityFilter || (dateRange[0] && dateRange[1])) && (
          <div className="mt-2 d-flex justify-content-end">
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={() => {
                setFacilityFilter("");
                setDateRange([null, null]);
              }}>
              Clear All Filters
            </button>
          </div>
        )}
      </div>

      {/* Utilization History Table */}
      <div className="border rounded-3" style={{ backgroundColor: "#f8f9fa" }}>
        <table className="table table-hover mb-0">
          <thead className="bg-white border-bottom">
            <tr>
              <th className="border px-3">ID</th>
              <th className="border px-3">Date & Time</th>
              <th className="border px-3">Location</th>
              <th className="border px-3">Tier</th>
              <th className="border px-3">Utilized</th>
            </tr>
          </thead>
          <tbody>
            {filteredRedemptions.length === 0 ? (
              <tr>
                <td colSpan={5} className="text-center py-5 border">
                  <div className="text-muted">
                    <span className="bi bi-inbox fs-1 d-block mb-2"></span>
                    <div className="fw-medium">
                      No utilization history found
                    </div>
                    <small>Try adjusting your filters</small>
                  </div>
                </td>
              </tr>
            ) : (
              filteredRedemptions.map((redemption, index) => (
                <tr key={redemption.id || index} className="border-bottom">
                  <td className="px-3 border">
                    <div className="fw-medium text-dark">#{index + 1}</div>
                  </td>
                  <td className="px-3 border">
                    <div className="fw-medium text-dark">
                      {new Date(redemption.createdAt).toLocaleDateString(
                        "en-US",
                        {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        }
                      )}
                    </div>
                    <small className="text-muted">
                      {new Date(redemption.createdAt).toLocaleTimeString()}
                    </small>
                  </td>
                  <td className="px-3 border">
                    <div className="fw-medium text-dark">
                      {redemption?.bill?.branch?.facility?.facilityName || "—"}
                    </div>
                    <small className="text-muted">
                      {redemption?.bill?.branch?.branchName || ""}
                    </small>
                  </td>
                  <td className="px-3 border">
                    <Badge
                      color="blue"
                      size="sm"
                      variant="light"
                      className="fw-medium">
                      {redemption?.benefit?.careCategory?.name || "Cashless"}
                    </Badge>
                  </td>
                  <td className="px-3 border">
                    <div className="fw-semibold text-success">
                      GHS {cedisLocale.format(redemption.amountRedeemed || 0)}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};


const getSponsorTermsLabel = (sponsor) => {
  const billing = sponsor?.billing;
  const contractTerms = billing?.contractTerms?.trim();
  return contractTerms || "—";
};

export const MembershipStatus = ({ membershipId: initialMembershipId }) => {
  const navigate = useNavigate();
  const [utilizationOpened, setUtilizationOpened] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchedMembershipId, setSearchedMembershipId] = useState(
    initialMembershipId || null
  );
  const [showSearch, setShowSearch] = useState(!initialMembershipId);

  // Use searchedMembershipId if available, otherwise use initialMembershipId
  const membershipId = searchedMembershipId || initialMembershipId;

  const {
    data: membershipData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryFn: () => getMembershipSubscription(membershipId),
    queryKey: ["subscription", membershipId],
    enabled: !!membershipId,
  });

  // Determine subscription ID for benefits (use primarySubscriptionId if exists, otherwise use id)
  const benefitsSubscriptionId =
    membershipData?.primarySubscriptionId || membershipData?.id;

  const { data: benefitsData, isLoading: isBenefitsLoading } = useQuery({
    queryFn: () => getMembershipBenefits(benefitsSubscriptionId),
    queryKey: ["membership-benefits", benefitsSubscriptionId],
    enabled: !!benefitsSubscriptionId && !!membershipData,
  });

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "active":
        return "teal";
      case "inactive":
      case "expired":
        return "red";
      case "pending":
        return "orange";
      default:
        return "gray";
    }
  };

  // Handle search
  const handleSearch = async () => {
    if (!searchValue.trim()) {
      message.error("Please enter a membership ID or access code");
      return;
    }
    setSearchedMembershipId(searchValue.trim());
    setShowSearch(false);
  };

  // Handle search toggle
  const handleToggleSearch = () => {
    setShowSearch(!showSearch);
    if (showSearch) {
      setSearchValue("");
      setSearchedMembershipId(null);
    }
  };

  // Show only search area when no membershipId
  if (!membershipId && !isLoading) {
    return (
      <div className="p-4 border rounded-3 bg-white">
        <div className="mb-3">
          <h5 className="fw-semibold mb-3">Membership Lookup</h5>
          <div className="row g-3">
            <div className="col-md-8">
              <label className="form-label small text-muted">
                Enter Membership ID or Access Code to proceed
              </label>
              <Input
                placeholder="Enter membership ID or access code"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                onPressEnter={handleSearch}
                size="large"
              />
            </div>
            <div className="col-md-4 d-flex align-items-end">
              <button
                className="btn btn-primary w-100"
                onClick={handleSearch}
                disabled={!searchValue.trim()}>
                <span className="bi bi-search me-2"></span>
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="p-4 border rounded-3 bg-white text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3 text-muted">Loading membership details...</p>
      </div>
    );
  }

  // if (isError) {
  //   return (
  //     <div>
  //       {/* Search Toggle */}
  //       <div className="mb-3 d-flex justify-content-between align-items-center">
  //         <button
  //           className="btn btn-sm btn-outline-secondary"
  //           onClick={handleToggleSearch}>
  //           <span className="bi bi-search me-2"></span>
  //           {showSearch ? "Hide Search" : "Search Another Membership"}
  //         </button>
  //       </div>

  //       {/* Search Area */}
  //       {showSearch && (
  //         <div className="mb-4 p-3 border rounded-3 bg-light">
  //           <div className="row g-3">
  //             <div className="col-md-8">
  //               <label className="form-label small text-muted">
  //                 Membership ID or Access Code
  //               </label>
  //               <Input
  //                 placeholder="Enter membership ID or access code"
  //                 value={searchValue}
  //                 onChange={(e) => setSearchValue(e.target.value)}
  //                 onPressEnter={handleSearch}
  //                 size="large"
  //               />
  //             </div>
  //             <div className="col-md-4 d-flex align-items-end">
  //               <button
  //                 className="btn btn-primary w-100"
  //                 onClick={handleSearch}
  //                 disabled={!searchValue.trim()}>
  //                 <span className="bi bi-search me-2"></span>
  //                 Search
  //               </button>
  //             </div>
  //           </div>
  //         </div>
  //       )}

  //       <div className="p-4 border rounded-3 bg-white">
  //         <div className="alert alert-danger">
  //           <i className="bi bi-exclamation-triangle me-2"></i>
  //           Error loading membership: {error?.message || "Unknown error"}
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  if (!membershipData || isError) {
    return (
      <div>
        {/* Search Toggle */}
        <div className="mb-3 d-flex justify-content-between align-items-center">
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={handleToggleSearch}>
            <span className="bi bi-search me-2"></span>
            {showSearch ? "Hide Search" : "Search Another Membership"}
          </button>
        </div>

        {/* Search Area */}
        {showSearch && (
          <div className="mb-4 p-3 border rounded-3 bg-light">
            <div className="row g-3">
              <div className="col-md-8">
                <label className="form-label small text-muted">
                  Membership ID or Access Code
                </label>
                <Input
                  placeholder="Enter membership ID or access code"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  onPressEnter={handleSearch}
                  size="large"
                />
              </div>
              <div className="col-md-4 d-flex align-items-end">
                <button
                  className="btn btn-primary w-100"
                  onClick={handleSearch}
                  disabled={!searchValue.trim()}>
                  <span className="bi bi-search me-2"></span>
                  Search
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="p-4 border rounded-3 bg-white">
          <div className="text-center py-5">
            <div className="mb-3">
              <i className="bi bi-search fs-1 text-muted"></i>
            </div>
            <h5 className="fw-semibold mb-2">No Membership Found</h5>
            <p className="text-muted mb-0">
              We couldn't find any membership records matching your search.
              <br />
              Please verify the Membership ID or Access Code and try again.
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Prepare benefits data from fetched benefits
  const benefits = benefitsData || [];
  const benefitType = membershipData?.benefitType?.toLowerCase();
  const isUnrestricted = benefitType === MEMBERSHIP_BENEFIT_TYPE.UNRESTRICTED;
  const isSegmented = benefitType === MEMBERSHIP_BENEFIT_TYPE.SEGMENTED;
  const isDiscounted = benefitType === MEMBERSHIP_BENEFIT_TYPE.DISCOUNTED;

  // Process benefits: for unrestricted, label as "Cashless"
  const processedBenefits =
    benefits.length > 0
      ? benefits.map((benefit) => ({
        ...benefit,
        categoryName: benefit.careCategory?.name || "Cashless",
      }))
      : [];

  // If no benefits but unrestricted type, show default Cashless entry
  // For discounted type, show empty array (no wallet balances)
  const displayBenefits = isDiscounted
    ? []
    : processedBenefits.length > 0
      ? processedBenefits
      : isUnrestricted
        ? [{ categoryName: "Cashless", totalBenefits: 0, balance: 0 }]
        : [];

  // Get voucher data if available
  const voucher = membershipData?.voucher;
  const sponsor = membershipData?.sponsor;
  const sponsorTermsLabel = getSponsorTermsLabel(sponsor);
  const canStartSession =
    membershipData?.patient?.id &&
    membershipData?.status?.toLowerCase() === "active";

  const handleStartSession = () => {
    if (!membershipData?.patient?.id) {
      message.warning("No patient is linked to this membership.");
      return;
    }
    navigate(appLinks.startConsultation.index, {
      state: { patient: membershipData.patient },
    });
  };

  // Render subscription
  return (
    <div>
      {/* Search Toggle */}
      <div className="mb-3 d-flex justify-content-between align-items-center gap-2">
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={handleToggleSearch}>
          <span className="bi bi-search me-2"></span>
          {showSearch ? "Hide Search" : "Search Another Membership"}
        </button>
        {canStartSession && (
          <button
            type="button"
            className="app-btn btn-prim btn-sm d-flex align-items-center gap-2 flex-shrink-0"
            onClick={handleStartSession}>
            <IconFirstAidKit size={18} />
            Start Session
          </button>
        )}
      </div>

      {/* Search Area */}
      {showSearch && (
        <div className="mb-4 p-3 border rounded-3 bg-light">
          <div className="row g-3">
            <div className="col-md-8">
              <label className="form-label small text-muted">
                Membership ID or Access Code
              </label>
              <Input
                placeholder="Enter membership ID or access code"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                onPressEnter={handleSearch}
                size="large"
              />
            </div>
            <div className="col-md-4 d-flex align-items-end">
              <button
                className="btn btn-primary w-100"
                onClick={handleSearch}
                disabled={!searchValue.trim()}>
                <span className="bi bi-search me-2"></span>
                Search
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="row g-4">
        {/* Membership Details Section */}
        <div className="col-md-6">
          {/* Status Component */}
          <div className="border rounded-3 bg-success bg-opacity-10 mb-3">
            <div className="row g-0">
              <div className="col-6 px-4 py-3 border-end">
                <div className="text-muted small mb-1">Status</div>
                <Badge
                  color={getStatusColor(membershipData?.status)}
                  size="md"
                  variant="filled">
                  {_.capitalize(membershipData?.status)}
                </Badge>
              </div>
              <div className="col-6 px-4 py-3">
                <div className="text-muted small mb-1">Membership Type</div>
                {membershipData?.membershipType ? (
                  <Badge
                    color={
                      membershipData?.membershipType === "primary"
                        ? "blue"
                        : "dark"
                    }
                    size="md"
                    variant="outline">
                    {_.capitalize(membershipData?.membershipType)}
                  </Badge>
                ) : (
                  <span className="text-muted">—</span>
                )}
              </div>
            </div>
          </div>

          <div className="border rounded-3 bg-white">
            <div className="list-group list-group-flush">
              {/* Member Information */}
              <div className="list-group-item px-4 py-3 d-flex align-items-start border-bottom">
                <div
                  className="me-3 d-flex align-items-center justify-content-center border rounded-circle"
                  style={{
                    width: 40,
                    height: 40,
                    borderColor: "#e9ecef",
                    flexShrink: 0,
                  }}>
                  <i
                    className="bi bi-person fs-6 text-dark"
                    style={{ opacity: 0.7 }}></i>
                </div>
                <div className="flex-fill">
                  <div className="row g-0">
                    <div className="col-6 border-end pe-3">
                      {membershipData?.patient?.firstName ||
                        membershipData?.patient?.lastName ? (
                        <>
                          <div
                            className="fw-bold mb-1"
                            style={{ color: "#212529" }}>
                            {membershipData?.patient?.firstName}{" "}
                            {membershipData?.patient?.lastName}
                          </div>
                          <div className="text-muted small">Member</div>
                        </>
                      ) : (
                        <div className="text-muted small">—</div>
                      )}
                    </div>
                    <div className="col-6 ps-3">
                      {membershipData?.membershipId ? (
                        <>
                          <div
                            className="fw-semibold mb-1"
                            style={{ color: "#212529" }}>
                            {membershipData.membershipId}
                          </div>
                          <div className="text-muted small">Membership ID</div>
                        </>
                      ) : (
                        <div className="text-muted small">—</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Membership Plan */}
              {/* {(membershipData?.package || membershipData?.tier) && (
                <div className="list-group-item px-4 py-3 d-flex align-items-start border-bottom">
                  <div
                    className="me-3 d-flex align-items-center justify-content-center border rounded-circle"
                    style={{
                      width: 40,
                      height: 40,
                      borderColor: "#e9ecef",
                      flexShrink: 0,
                    }}>
                    <i
                      className="bi bi-shield-check fs-6 text-dark"
                      style={{ opacity: 0.7 }}></i>
                  </div>
                  <div className="flex-fill">
                    <div className="fw-bold mb-1" style={{ color: "#212529" }}>
                      {membershipData?.package?.packageName ||
                        membershipData?.tier?.tierName ||
                        "Standard Plan"}
                    </div>
                    <div className="text-muted small">Membership Plan</div>
                  </div>
                </div>
              )} */}

              {/* Access Type and Card Code */}
              <div className="list-group-item px-4 py-3 d-flex align-items-start border-bottom">
                <div
                  className="me-3 d-flex align-items-center justify-content-center border rounded-circle"
                  style={{
                    width: 40,
                    height: 40,
                    borderColor: "#e9ecef",
                    flexShrink: 0,
                  }}>
                  <i
                    className="bi bi-heart-pulse fs-6 text-dark"
                    style={{ opacity: 0.7 }}></i>
                </div>
                <div className="flex-fill">
                  <div className="row g-0">
                    <div className="col-6 border-end pe-3">
                      <div
                        className="fw-bold mb-1"
                        style={{ color: "#212529" }}>
                        {isUnrestricted
                          ? "Cashless"
                          : isDiscounted
                            ? "Discounted"
                            : "Segmented"}
                      </div>
                      <div className="text-muted small">Access Type</div>
                    </div>
                    <div className="col-6 ps-3">
                      {voucher?.code ? (
                        <>
                          <div
                            className="fw-bold mb-1"
                            style={{ color: "#212529" }}>
                            {voucher.code}
                          </div>
                          <div className="text-muted small">Access Code</div>
                        </>
                      ) : (
                        <div className="text-muted small">—</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Membership Dates */}
              {(membershipData?.startDate || membershipData?.endDate) && (
                <div className="list-group-item px-4 py-3 d-flex align-items-start border-bottom">
                  <div
                    className="me-3 d-flex align-items-center justify-content-center border rounded-circle"
                    style={{
                      width: 40,
                      height: 40,
                      borderColor: "#e9ecef",
                      flexShrink: 0,
                    }}>
                    <i
                      className="bi bi-calendar3 fs-6 text-dark"
                      style={{ opacity: 0.7 }}></i>
                  </div>
                  <div className="flex-fill">
                    <div className="row g-0">
                      <div className="col-6 border-end pe-3">
                        {membershipData?.startDate ? (
                          <>
                            <div
                              className="fw-bold mb-1"
                              style={{ color: "#212529" }}>
                              {new Date(
                                membershipData.startDate
                              ).toLocaleDateString("en-US", {
                                month: "long",
                                day: "numeric",
                                year: "numeric",
                              })}
                            </div>
                            <div className="text-muted small">
                              Activation Date
                            </div>
                          </>
                        ) : (
                          <div className="text-muted small">—</div>
                        )}
                      </div>
                      <div className="col-6 ps-3">
                        {membershipData?.endDate ? (
                          <>
                            <div
                              className="fw-bold mb-1"
                              style={{ color: "#212529" }}>
                              {new Date(
                                membershipData.endDate
                              ).toLocaleDateString("en-US", {
                                month: "long",
                                day: "numeric",
                                year: "numeric",
                              })}
                            </div>
                            <div className="text-muted small">Expiry Date</div>
                          </>
                        ) : (
                          <div className="text-muted small">—</div>
                        )}
                        {/* {membershipData?.term && (
                        <Badge color="gray" size="sm" variant="outline">
                          {membershipData.term} mos
                        </Badge>
                      )} */}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Amount Paid */}
              {/* <div className="list-group-item px-4 py-3 d-flex align-items-start border-bottom">
                <div
                  className="me-3 d-flex align-items-center justify-content-center border rounded-circle"
                  style={{
                    width: 40,
                    height: 40,
                    borderColor: "#e9ecef",
                    flexShrink: 0,
                  }}>
                  <i
                    className="bi bi-cash-coin fs-6 text-dark"
                    style={{ opacity: 0.7 }}></i>
                </div>
                <div className="flex-fill">
                  <div className="fw-bold mb-1" style={{ color: "#212529" }}>
                    GHS {cedisLocale.format(membershipData?.amountPaid || 0)}
                  </div>
                  <div className="text-muted small">Access Fee</div>
                </div>
              </div> */}

              {/* Channel/Sponsor */}
              {sponsor?.sponsorName && (
                <div className="list-group-item px-4 py-3 d-flex align-items-start border-bottom">
                  <div
                    className="me-3 d-flex align-items-center justify-content-center border rounded-circle"
                    style={{
                      width: 40,
                      height: 40,
                      borderColor: "#e9ecef",
                      flexShrink: 0,
                    }}>
                    <i
                      className="bi bi-building fs-6 text-dark"
                      style={{ opacity: 0.7 }}></i>
                  </div>
                  <div className="flex-fill">
                    <div className="fw-bold mb-1" style={{ color: "#212529" }}>
                      {sponsor.sponsorName}
                      {sponsor.sponsorType && (
                        <span className="text-muted fw-normal ms-1">
                          ({_.capitalize(sponsor.sponsorType)})
                        </span>
                      )}
                    </div>
                    <div className="small d-flex flex-column gap-3 border-top pt-3 mt-2">
                      <div className="d-flex justify-content-between align-items-start gap-3">
                        <span
                          className="text-muted text-uppercase fw-semibold flex-shrink-0"
                          style={{ fontSize: "0.7rem", letterSpacing: "0.04em" }}>
                          Location
                        </span>
                        <span
                          className="text-end fw-semibold"
                          style={{ color: "#212529" }}>
                          {sponsor.location || "—"}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between align-items-start gap-3">
                        <span
                          className="text-muted text-uppercase fw-semibold flex-shrink-0"
                          style={{ fontSize: "0.7rem", letterSpacing: "0.04em" }}>
                          Contact
                        </span>
                        <span
                          className="text-end fw-semibold"
                          style={{ color: "#212529" }}>
                          {sponsor.contact || "—"}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between align-items-start gap-3">
                        <span
                          className="text-muted text-uppercase fw-semibold flex-shrink-0"
                          style={{ fontSize: "0.7rem", letterSpacing: "0.04em" }}>
                          Contact person
                        </span>
                        <span
                          className="text-end fw-semibold"
                          style={{ color: "#212529" }}>
                          {sponsor.contactPerson || "—"}
                        </span>
                      </div>
                      <div className="pt-1">
                        <div
                          className="text-muted text-uppercase fw-semibold mb-2"
                          style={{ fontSize: "0.7rem", letterSpacing: "0.04em" }}>
                          Terms
                        </div>
                        {sponsorTermsLabel ? (
                          <div
                            className="fw-medium"
                            style={{ color: "#212529", whiteSpace: "pre-wrap" }}
                            dangerouslySetInnerHTML={{
                              __html: sponsorTermsLabel,
                            }}
                          />
                        ) : (
                          <span className="fw-semibold" style={{ color: "#212529" }}>
                            —
                          </span>
                        )}
                      </div>
                    </div>

                  </div>
                </div>
              )}
            </div>

          </div>
        </div>
        {/* Benefits Section */}
        <div className="col-md-6">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <Text size="lg" weight={600}>
             Care Value
            </Text>
            <button
              className="btn app-btn btn-sm d-flex fw-medium align-items-center gap-2"
              onClick={() => setUtilizationOpened(true)}>
              <IconHistory size={16} />
              View Usage History
            </button>
          </div>

          {isBenefitsLoading ? (
            <div className="border rounded-3 bg-white">
              <div className="list-group-item px-4 py-4 text-center d-flex align-items-center justify-content-center">
                <div
                  className="spinner-border spinner-border-sm text-primary me-2"
                  role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <Text size="sm" color="dimmed">
                  Loading benefits...
                </Text>
              </div>
            </div>
          ) : displayBenefits.length === 0 ? (
            <div className="border rounded-3 bg-white">
              <div className="list-group-item px-4 py-4 text-center">
                <Text size="sm" color="dimmed">
                  <i className="bi bi-info-circle me-2"></i>
                  {isDiscounted
                    ? "Regular membership - no care value"
                    : isSegmented
                      ? "No value allocated yet for this segmented membership"
                      : "No care value for this membership"}
                </Text>
              </div>
            </div>
          ) : (
            <>
            <div className="border rounded-3 bg-white">
              {/* Benefits Table Header */}
              <div className="list-group-item px-4 py-2 border-bottom bg-light">
                <div className="row g-0 text-muted small fw-semibold">
                  <div className="col-4">Tier</div>
                  <div className="col-3">Total</div>
                  <div className="col-2">Used</div>
                  <div className="col-3 text-end">Balance</div>
                </div>
              </div>
              <div className="list-group list-group-flush">
                {displayBenefits.map((benefit, index) => {
                  const totalBenefits = benefit.totalBenefits || 0;
                  const balance = benefit.balance || 0;
                  const used = totalBenefits - balance;
                  const isLowBalance =
                    totalBenefits > 0 && balance / totalBenefits < 0.1;

                  return (
                    <div
                      key={benefit.id || index}
                      className={`list-group-item px-4 py-3 ${index < displayBenefits.length - 1
                        ? "border-bottom"
                        : ""
                        }`}>
                      <div className="row g-0 align-items-center">
                        <div className="col-4">
                          <div className="d-flex align-items-center">
                            <div
                              className="me-2 d-flex align-items-center justify-content-center border rounded-circle"
                              style={{
                                width: 32,
                                height: 32,
                                borderColor: "#e9ecef",
                                flexShrink: 0,
                              }}>
                              <i
                                className="bi bi-wallet2"
                                style={{ fontSize: "14px", opacity: 0.7 }}></i>
                            </div>
                            <div>
                              <div
                                className="fw-semibold"
                                style={{ color: "#212529" }}>
                                {benefit.categoryName}
                              </div>
                              {isLowBalance && (
                                <Badge
                                  color="orange"
                                  size="xs"
                                  variant="light"
                                  className="mt-1">
                                  Low Balance
                                </Badge>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-3">
                          <div
                            className="fw-semibold"
                            style={{ color: "#212529" }}>
                            GHS {cedisLocale.format(totalBenefits)}
                          </div>
                        </div>
                        <div className="col-2">
                          <div className="fw-semibold text-danger">
                            GHS {cedisLocale.format(used)}
                          </div>
                        </div>
                        <div className="col-3 text-end">
                          <div
                            className={`fw-bold ${isLowBalance ? "text-warning" : "text-success"
                              }`}>
                            GHS {cedisLocale.format(balance)}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="border rounded-3 bg-white mt-3 p-3">
              <div className="text-muted small fw-semibold mb-2">
                Care value utilization
              </div>
              <CareValueChart benefits={displayBenefits} />
            </div>
            </>
          )}
        </div>
      </div>

      {/* Membership Utilization Modal */}
      <Modal
        opened={utilizationOpened}
        onClose={() => setUtilizationOpened(false)}
        title={
          <div className="d-flex align-items-center gap-2">
            <IconHistory size={20} />
            <span className="fw-semibold">Utilization History</span>
          </div>
        }
        size="xl"
        centered>
        <MembershipUtilization membershipId={membershipId} />
      </Modal>
    </div>
  );
};

export const PayoutDetail = ({ payoutId }) => {
  const { data: payout, isLoading } = useQuery({
    queryFn: () => getPayoutById(payoutId),
    queryKey: ["payout", payoutId],
    enabled: !!payoutId,
  });

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center p-4">
        <Loader size="md" />
      </div>
    );
  }

  if (!payout) {
    return (
      <div className="p-4">
        <Text color="dimmed">Payout not found</Text>
      </div>
    );
  }

  const getStatusIcon = (status) => {
    return <IconCircleCheck size={16} color="teal" />;
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "submitted":
        return "blue";
      case "pending":
      case "review":
        return "yellow";
      case "approved":
        return "teal";
      case "paid":
        return "green";
      case "rejected":
        return "red";
      default:
        return "gray";
    }
  };

  return (
    <div className="row">
      <div className="col-md-5">
        <div
          className="d-flex align-items-start mb-4"
          style={{ cursor: "pointer" }}>
          <div
            className="d-flex align-items-center justify-content-center me-3"
            style={{
              width: "48px",
              height: "48px",
              borderRadius: "50%",
              backgroundColor: "#f3f4f6",
              flexShrink: 0,
            }}>
            <IconCreditCard size={24} color="#6b7280" stroke={1.5} />
          </div>
          <div className="flex-grow-1">
            <Text size="md" fw={600} style={{ color: "#1f2937" }}>
              GHS {cedisLocale.format(payout.amountRequested)}
            </Text>
            <Text size="sm" color="dimmed">
              Amount
            </Text>
          </div>
        </div>

        <div
          className="d-flex align-items-start mb-4"
          style={{ cursor: "pointer" }}>
          <div
            className="d-flex align-items-center justify-content-center me-3"
            style={{
              width: "48px",
              height: "48px",
              borderRadius: "50%",
              backgroundColor: "#f3f4f6",
              flexShrink: 0,
            }}>
            <IconReceipt size={24} color="#6b7280" stroke={1.5} />
          </div>
          <div className="flex-grow-1">
            <Text size="md" fw={600} style={{ color: "#1f2937" }}>
              <Badge
                color={payout.isPaid ? "teal" : "orange"}
                size="lg"
                variant="light">
                {payout.isPaid ? "Paid" : "Pending"}
              </Badge>
            </Text>
            <Text size="sm" color="dimmed">
              Payout Status
            </Text>
          </div>
        </div>

        {payout.reference && (
          <div
            className="d-flex align-items-start mb-4"
            style={{ cursor: "pointer" }}>
            <div
              className="d-flex align-items-center justify-content-center me-3"
              style={{
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                backgroundColor: "#f3f4f6",
                flexShrink: 0,
              }}>
              <IconCreditCard size={24} color="#6b7280" stroke={1.5} />
            </div>
            <div className="flex-grow-1">
              <Text size="md" fw={600} style={{ color: "#1f2937" }}>
                {payout.reference}
              </Text>
              <Text size="sm" color="dimmed">
                Payment Reference
              </Text>
            </div>
          </div>
        )}

        <div
          className="d-flex align-items-start mb-4"
          style={{ cursor: "pointer" }}>
          <div
            className="d-flex align-items-center justify-content-center me-3"
            style={{
              width: "48px",
              height: "48px",
              borderRadius: "50%",
              backgroundColor: "#f3f4f6",
              flexShrink: 0,
            }}>
            <IconCalendar size={24} color="#6b7280" stroke={1.5} />
          </div>
          <div className="flex-grow-1">
            <Text size="md" fw={600} style={{ color: "#1f2937" }}>
              {format(new Date(payout.date), "EEE, MMM dd, yyyy")}
            </Text>
            <Text size="sm" color="dimmed">
              Submission Date
            </Text>
          </div>
        </div>

        <div
          className="d-flex align-items-start mb-4"
          style={{ cursor: "pointer" }}>
          <div
            className="d-flex align-items-center justify-content-center me-3"
            style={{
              width: "48px",
              height: "48px",
              borderRadius: "50%",
              backgroundColor: "#f3f4f6",
              flexShrink: 0,
            }}>
            <IconCalendar size={24} color="#6b7280" stroke={1.5} />
          </div>
          <div className="flex-grow-1">
            <Text size="md" fw={600} style={{ color: "#1f2937" }}>
              {format(new Date(payout.date), "h:mm a")}
            </Text>
            <Text size="sm" color="dimmed">
              Submission Time
            </Text>
          </div>
        </div>

        {payout.bill?.patient && (
          <div
            className="d-flex align-items-start mb-4"
            style={{ cursor: "pointer" }}>
            <div
              className="d-flex align-items-center justify-content-center me-3"
              style={{
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                backgroundColor: "#f3f4f6",
                flexShrink: 0,
              }}>
              <IconUser size={24} color="#6b7280" stroke={1.5} />
            </div>
            <div className="flex-grow-1">
              <Text size="md" fw={600} style={{ color: "#1f2937" }}>
                {payout.bill.patient.firstName} {payout.bill.patient.lastName}
              </Text>
              <Text size="sm" color="dimmed">
                Member
              </Text>
            </div>
          </div>
        )}
      </div>

      <div className="col-md-7">
        <Text size="md" fw={600} className="mb-3">
          Status History
        </Text>
        {payout.statusHistory && payout.statusHistory.length > 0 ? (
          <Timeline active={-1} bulletSize={24} lineWidth={2}>
            {payout.statusHistory.map((history) => (
              <Timeline.Item
                key={history.id}
                bullet={getStatusIcon(history.status)}
                title={
                  <Badge
                    color={getStatusColor(history.status)}
                    size="md"
                    variant="light"
                    className="text-capitalize">
                    {history.status}
                  </Badge>
                }>
                <Text size="xs" color="dimmed" className="mb-2">
                  {format(new Date(history.createdAt), "MMM dd, yyyy hh:mm a")}
                </Text>
                {history.notes && (
                  <Text size="sm" className="mt-1">
                    {history.notes}
                  </Text>
                )}
              </Timeline.Item>
            ))}
          </Timeline>
        ) : (
          <Text size="sm" color="dimmed">
            No status history available
          </Text>
        )}
      </div>
    </div>
  );
};

export const LinkBillToConsultation = ({ onLink }) => {
  const [code, setCode] = useState("");
  const [isLoading, setLoading] = useState(false);

  return (
    <div className="row">
      <div className="col-12 text-center mt-3">
        <label className="mb-0 label" htmlFor="title">
          Enter consultation code
        </label>
        <div className="field">
          <input
            className="w-75 input text-center mt-2"
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            autoFocus
            id="title"
            placeholder="code here"
          />
        </div>
        <button
          onClick={() => {
            if (code === "") {
              message.error("code required");
              return;
            }
            setLoading(true);
            onLink(code);
          }}
          className={`mt-3 button h6 app-btn btn-prim ${isLoading && " is-loading"
            }`}>
          <span className="bi bi-link-45deg me-2" />
          Link
        </button>
      </div>
    </div>
  );
};

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Example "componentStack":
    //   in ComponentThatThrows (created by App)
    //   in ErrorBoundary (created by App)
    //   in div (created by App)
    //   in App
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.fallback;
    }

    return this.props.children;
  }
}
